/**
 * Client-side cap for the free-text pipe-spec fields.
 *
 * Mirrors `MAX_SPEC_TEXT_LENGTH` in the API (`src/constants/spec-text.ts`).
 * The API is the authority — it rejects with a 400 naming the field — and this
 * is the courtesy copy that stops the round trip. Both numbers must move
 * together; the API's docblock explains why the number is what it is.
 *
 * These inputs previously carried 50 (ConnectionTypeSelect) and 100
 * (TopDriveThreadSelect), which were neither the storage limit nor each other.
 * The 50 was what let PAR Energy save a 27-character connection name into a
 * lookup whose value then 500'd on a varchar(20) job column. Migration 0299
 * made those columns `text`; this is now the only length rule in the system,
 * which is why it is a named constant and not a literal in the JSX.
 */
export const MAX_SPEC_TEXT_LENGTH = 200;
